class SellingPlans extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleOptionValueChange.bind(this),
    );

    this.productForm = this.closest('product-form');
    this.purchaseTypeInputs = this.querySelectorAll('[type="radio"]');
    this.sellingPlanInput = this.querySelector('[name="selling_plan"]');
    this.planAttributes = this.querySelectorAll(
      '[data-subscription-variant-attribute]',
    );

    this.purchaseTypeInputs.forEach((input) =>
      input.addEventListener(
        'change',
        this.handleOnPurchaseTypeChange.bind(this),
      ),
    );
  }

  disconnectedCallback() {
    this.onVariantChangeUnsubscriber();
  }

  handleOptionValueChange() {
    if (!this.productForm.selectedVariant) return;

    const allocations = this.discountedAllocations();
    const hasPlans = allocations.length > 0;

    this.classList.toggle('has-no-plan', !hasPlans);

    // The subscription option is hidden for plan-less variants; a hidden
    // checked radio would still submit, so select one-time explicitly.
    if (!hasPlans) {
      const oneTimeInput = Array.from(this.purchaseTypeInputs).find(
        (input) => input.value === 'one-time',
      );

      if (oneTimeInput) oneTimeInput.checked = true;
    }

    const purchaseType = Array.from(this.purchaseTypeInputs).find(
      (input) => input.checked,
    )?.value;

    this.sellingPlanInput.value =
      purchaseType !== 'one-time'
        ? allocations?.[0]?.selling_plan_id || ''
        : '';

    // Price spans follow the variant, not the chosen purchase type: the
    // subscription card shows its own price even while one-time is selected.
    // Comparing against the input value instead left the subscription price
    // hidden after landing on a plan-less variant and switching away.
    const variantPlanId = String(allocations?.[0]?.selling_plan_id || '');

    this.planAttributes.forEach((element) => {
      if (element.hasAttribute('data-selling-plan-id')) {
        element.classList.toggle(
          'hidden',
          element.dataset.variantId !==
            String(this.productForm.selectedVariant.id) ||
            element.dataset.sellingPlanId !== variantPlanId,
        );
      } else {
        element.classList.toggle(
          'hidden',
          element.dataset.variantId !==
            String(this.productForm.selectedVariant.id),
        );
      }
    });
    this.productForm.toggleSubmitButton(false);
  }

  handleOnPurchaseTypeChange(event) {
    this.sellingPlanInput.value =
      event.target.value !== 'one-time'
        ? this.discountedAllocations()[0]?.selling_plan_id || ''
        : '';
    this.productForm.toggleSubmitButton(false);
  }

  // Subscribe shows only for plans with a discount: the stick pack plans (no
  // discount) belong to the new plan picker that isn't live yet.
  discountedAllocations() {
    const variant = this.productForm.selectedVariant;

    return (variant?.selling_plan_allocations || []).filter(
      (allocation) => allocation.price < variant.price,
    );
  }
}

customElements.define('selling-plans', SellingPlans);
